<mat-form-field [appearance]="appearance">
  <mat-label>{{ label }}</mat-label>
  <mat-select
    [value]="value"
    (selectionChange)="onSelectionChange($event.value)"
    (blur)="onTouched()"
    [disabled]="disabled"
    [required]="isRequired"
    [errorStateMatcher]="errorStateMatcher"
  >
    @if (nullable) {
      <mat-option [value]="null" class="null-value">Aucune</mat-option>
    }
    @for (company of companyService.allCompanies$ | async; track $index) {
      <mat-option [value]="company.id">
        {{ company.name }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
